import { render, staticRenderFns } from "./forwardMessageDialog.vue?vue&type=template&id=c66e269a&scoped=true"
import script from "./forwardMessageDialog.vue?vue&type=script&lang=js"
export * from "./forwardMessageDialog.vue?vue&type=script&lang=js"
import style0 from "./forwardMessageDialog.vue?vue&type=style&index=0&id=c66e269a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66e269a",
  null
  
)

export default component.exports